import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import KBSidebar from "./components/KBSidebar";
import KBTabMenu from "./components/KBTabMenu";
import KBSectionLinks from "./components/KBSectionLinks";
import KBContentLoader from "./components/KBContentLoader";
import { categoryData } from "./data/categories";
import "./styles/kb.css";

const KnowledgeBase = () => {
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState("scans");
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [activeSections, setActiveSections] = useState([]);
  const [hash, setHash] = useState("");
  
  // Parse hash to determine active category/subcategory
  useEffect(() => {
    if (location.hash) {
      const hashValue = location.hash.replace('#', '');
      setHash(hashValue);
      
      // Check if hash matches main category
      const categoryMatch = Object.keys(categoryData).find(cat => cat === hashValue);
      if (categoryMatch) {
        setActiveCategory(categoryMatch);
        
        // Set first subcategory as active by default if available
        const subcategories = categoryData[categoryMatch]?.subcategories;
        if (subcategories && subcategories.length > 0) {
          setActiveSubcategory(subcategories[0].id);
        } else {
          setActiveSubcategory(null);
        }
      } else {
        // Check if hash contains a subcategory (format: category-subcategory)
        const parts = hashValue.split("-");
        if (parts.length > 1) {
          const category = parts[0];
          const subcategory = parts.slice(1).join("-");
          
          if (categoryData[category]) {
            setActiveCategory(category);
            setActiveSubcategory(subcategory);
          }
        }
      }
    } else {
      // Default to first category and subcategory if no hash
      const firstCategory = Object.keys(categoryData)[0];
      setActiveCategory(firstCategory);
      
      const subcategories = categoryData[firstCategory]?.subcategories;
      if (subcategories && subcategories.length > 0) {
        setActiveSubcategory(subcategories[0].id);
      }
    }
  }, [location.hash]);
  
  // Get subcategories for current category
  const subcategories = categoryData[activeCategory]?.subcategories || [];
  
  // Handle category change from sidebar
  const handleCategoryChange = (category) => {
    setActiveCategory(category);
    
    // Set first subcategory as active by default
    const subs = categoryData[category]?.subcategories;
    if (subs && subs.length > 0) {
      setActiveSubcategory(subs[0].id);
    } else {
      setActiveSubcategory(null);
    }
  };
  
  // Handle subcategory change from tab menu
  const handleSubcategoryChange = (subcategoryId) => {
    setActiveSubcategory(subcategoryId);
    // Update URL hash without reloading page
    window.history.replaceState(
      null, 
      null, 
      `#${activeCategory}-${subcategoryId}`
    );
  };
  
  // Load sections for current subcategory
  useEffect(() => {
    if (activeCategory && activeSubcategory) {
      const category = categoryData[activeCategory];
      if (category) {
        const subcategory = category.subcategories?.find(sub => sub.id === activeSubcategory);
        if (subcategory) {
          setActiveSections(subcategory.sections || []);
        } else {
          setActiveSections([]);
        }
      }
    }
  }, [activeCategory, activeSubcategory]);
  
  return (
    <div className="serviceBox">
      {/* <div className="textboxMain">
        <h6>Yggdrasil Knowledge Tree</h6>
        <div className="box" style={{ "marginLeft": "20px" }}>
          <p>Browse through our knowledge base to find guidance about the platform or use the iOdin AI Chat. 
            Here you will find everything from details about how to use the platform, 
            general information about how the scans work, to remediation and mitigation guidance.</p>
        </div>
      </div>*/}
        {/*<div className="bottom_panel bottom_panel_Services active_bottom_panel" id="bottom_panel">*/}
        <div className="bottom_panel bottom_panel_KB active_bottom_panel" id="bottom_panel">
            <div className="bottom_panel_header">
                <div className="tab_boxes">
                    {/* Main category header */}
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <div className="boxA">
                        <div className="upper_box">
                            <img 
                            src={categoryData[activeCategory]?.icon || "/assets/images/Identify_Valkyrie.svg"} 
                            className="img-fluid" 
                            alt="" 
                            />
                            <div className="text_box">
                            <p>{categoryData[activeCategory]?.title || "Knowledge Base"}</p>
                            <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                                <div className="progress-bar blue_progress_bar" style={{ width: "100%" }}></div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </li>
                    
                    {/* Subcategory tabs */}
                    {subcategories.map(subcategory => (
                        <li className="nav-item" role="presentation" key={subcategory.id}>
                        <button 
                            className={`nav-link ${activeSubcategory === subcategory.id ? 'active' : ''}`}
                            id={`${subcategory.id}-tab`}
                            data-bs-toggle="tab"
                            data-bs-target={`#${subcategory.id}-pane`}
                            type="button"
                            role="tab"
                            aria-controls={`${subcategory.id}-pane`}
                            aria-selected={activeSubcategory === subcategory.id}
                            onClick={() => handleSubcategoryChange(subcategory.id)}
                        >
                            <div className="inner_tab_button">
                            <img src={subcategory.icon} className="img-fluid" alt="" />
                            <p>{subcategory.title}</p>
                            </div>
                        </button>
                        </li>
                    ))}
                    </ul>
                    
                    {/* Section content */}
                    <div className="tab-content" id="myTabContent">
                    {subcategories.length > 0 ? (
                        // Categories with subcategories
                        subcategories.map(subcategory => (
                            <div 
                            className={`tab-pane fade ${activeSubcategory === subcategory.id ? 'show active' : ''}`}
                            id={`${subcategory.id}-pane`}
                            role="tabpanel"
                            aria-labelledby={`${subcategory.id}-tab`}
                            tabIndex="0"
                            key={subcategory.id}
                            >
                            <div className="d-flex">
                                <div className="d-flex-serviceTab">
                                <img src={subcategory.icon} alt={subcategory.title} />
                                <h2>{subcategory.title}</h2>
                                </div>
                                <div className="boxContent">
                                {/* Section links if available */}
                                {subcategory.sections && subcategory.sections.length > 0 && (
                                    <KBSectionLinks 
                                    sections={subcategory.sections} 
                                    category={activeCategory} 
                                    subcategory={subcategory.id} 
                                    />
                                )}
                                
                                {/* Dynamic content loader */}
                                <KBContentLoader 
                                    category={activeCategory} 
                                    subcategory={subcategory.id} 
                                />
                                </div>
                            </div>
                            </div>
                        ))
                    ) : (
                        // Simple categories without subcategories (FAQ, Troubleshooting, etc.)
                        <div className="tab-pane fade show active" role="tabpanel" tabIndex="0">
                            <div className="d-flex">
                                <div className="d-flex-serviceTab">
                                <img 
                                    src={categoryData[activeCategory]?.icon || "/assets/images/Identify_Valkyrie.svg"} 
                                    alt={categoryData[activeCategory]?.title || activeCategory} 
                                />
                                <h2>{categoryData[activeCategory]?.title || activeCategory}</h2>
                                </div>
                                <div className="boxContent">
                                {/* Dynamic content loader for simple categories */}
                                <KBContentLoader 
                                    category={activeCategory} 
                                    subcategory={null} 
                                />
                                </div>
                            </div>
                        </div>
                    )}
                    </div>
                </div>
                
                {/* Right status box */}
                <div className="boxA boxB">
                    <div className="upper_box">
                    <div className="text_box">
                        <span>You're at</span>
                        <p>Knowledge Base</p>
                        <div className="progress" role="progressbar" aria-label="Basic example" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                        <div className="progress-bar blue_progress_bar" style={{ width: "100%" }}></div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default KnowledgeBase;